import { Layout, Row, Col, MenuProps, Dropdown, Avatar, Button } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Home } from './routes/public/Home';
import { CoursArabesEnfantForm } from './routes/public/CoursArabesEnfantForm';
import { AdminCoursArabes } from './routes/admin/AdminCoursArabes';
import { MyMenu } from './components/MyMenu';
import { BottomNavigation } from './components/BottomNavigation';
import { ChangePassword } from './routes/admin/ChangePasswordForm';
import { AdhesionForm } from './routes/public/AdhesionForm';
import { AdminAdhesion } from './routes/admin/AdminAdhesion';
import { AdminTarifs } from './routes/admin/AdminTarifs';
import { FaireUnDon } from './routes/public/FaireUnDon';
import { Parametres } from './routes/admin/Parametres';
import { HomeAdmin } from './routes/admin/HomeAdmin';
import { CoursArabesAdulteForm } from './routes/public/CoursArabesAdulteForm';
import { useAuth } from './hooks/AuthContext';
import { SignIn } from './routes/admin/SignIn';
import CreateUpdateClasse from './routes/admin/CreateUpdateClasse';
import MesClasses from './routes/enseignant/MesClasses';
import MaClasse from './routes/enseignant/MaClasse';
import { NotFound } from './routes/public/NotFound';
import AdhesionInfos from './routes/public/AdhesionInfos';
import { useEffect } from 'react';
import useApi from './hooks/useApi';
import { MATIERES_ENDPOINT } from './services/services';
import { useMatieresStore } from './components/stores/useMatieresStore';
import { TraductionDto, TypeMatiereEnum } from './services/classe';
import Utilisateurs from './routes/admin/Utilisateurs';
import AccountActivation from './routes/public/AccountActivation';
import DashboardUtilisateur from './routes/utilisateur/DashboardUtilisateur';
import ReinscriptionEnfantForm from './routes/utilisateur/ReinscriptionEnfantForm';
import ReinscriptionAdulteForm from './routes/utilisateur/ReinscriptionAdulteForm';
import ResetPassword from './routes/public/ResetPassword';
import { LoginOutlined } from '@ant-design/icons';

const { Header, Content, Footer } = Layout;

function App() {
  const { username, prenom, logout, requestProfileInformations } = useAuth();
  const navigate = useNavigate();
  const { execute } = useApi();
  const { setMatieres } = useMatieresStore();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const DropdownAuthUser = () => {
    const handleMenuClick = (e: any) => {
      if (e.key === "1" && logout) {
        logout();
      } else if (e.key === "2") {
        navigate("/changePassword");
      }
    };

    const items: MenuProps['items'] = [
      {
        label: "Se déconnecter",
        key: "1",
        className: "dropdown-item"
      },
      {
        label: "Modifier mot de passe",
        key: "2",
        className: "dropdown-item"
      }
    ];

    const menu: MenuProps = {
      items,
      onClick: handleMenuClick,
      className: "user-dropdown"
    };
    return (
      <Dropdown menu={menu}>
        <Avatar style={{ backgroundColor: "orange", verticalAlign: "middle", cursor: "pointer", color: "black" }} size="large">
          {prenom ?? username}
        </Avatar>
      </Dropdown>
    );
  };

  useEffect(() => {
    requestProfileInformations();
  }, []);

  useEffect(() => {
    const loadData = async () => {
      const { successData: matieres } = await execute<Record<TypeMatiereEnum, TraductionDto[]>>({ method: "GET", url: MATIERES_ENDPOINT });
      if (matieres) {
        setMatieres(matieres);
      }
    }
    loadData();
  }, []);

  return (
    <Layout>
      {!isMobile && (
        <Header className="desktop-header">
          <div className="header-left">
            <div className="logo" />
            <div className="logo-title">Association musulmane du Chablais</div>
          </div>
          <div className="header-center">
            <MyMenu />
          </div>
          <div className="header-right">
            {username ? (
              <DropdownAuthUser />
            ) : (
              <Button type="primary" onClick={() => navigate("/login")} icon={<LoginOutlined />}>
                Se connecter
              </Button>
            )}
          </div>
        </Header>
      )}
      {isMobile && (
        <Header style={{ padding: "0 16px", height: "56px", lineHeight: "56px" }}>
          <Row justify="center" align="middle">
            <Col>
              <div className="logo" style={{ display: "inline-block", verticalAlign: "middle" }} />
            </Col>
          </Row>
        </Header>
      )}
      <Content className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/coursEnfants" element={<CoursArabesEnfantForm />} />
          <Route path="/coursEnfants/:id" element={<CoursArabesEnfantForm />} />
          <Route path="/coursAdultes" element={<CoursArabesAdulteForm />} />
          <Route path="/coursAdultes/:id" element={<CoursArabesAdulteForm />} />
          <Route path="/adhesions" element={<AdhesionForm />} />
          <Route path="/adhesions/:id" element={<AdhesionForm />} />
          <Route path="/adhesionInfos" element={<AdhesionInfos />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/admin" element={<HomeAdmin />} />
          <Route path="/adminCours" element={<AdminCoursArabes />} />
          <Route path="/adminAdhesion" element={<AdminAdhesion />} />
          <Route path="/adminTarif" element={<AdminTarifs />} />
          <Route path="/creerModifierClasse" element={<CreateUpdateClasse />} />
          <Route path="/classes" element={<MesClasses />} />
          <Route path="/classes/:id" element={<MaClasse />} />
          <Route path="/changePassword" element={<ChangePassword />} />
          <Route path="/don" element={<FaireUnDon />} />
          <Route path="/parametres" element={<Parametres />} />
          <Route path="/utilisateurs" element={<Utilisateurs />} />
          <Route path="/dashboard" element={<DashboardUtilisateur />} />
          <Route path="/reinscriptionEnfants" element={<ReinscriptionEnfantForm />} />
          <Route path="/reinscriptionAdultes" element={<ReinscriptionAdulteForm />} />
          <Route path="/accountActivation" element={<AccountActivation />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Content>
      <Footer className="footer">
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} md={8} className="footer-section">
            <h3 className="footer-title">Association Musulmane du Chablais</h3>
            <p>5 chemin des Epinanches</p>
            <p>74200 Thonon-les-Bains</p>
            <p>
              Tel: <a href="tel:+33450706478" className="footer-link">(+33) 4 50 70 64 78</a><br />
              Email: <a href="mailto:amcinscription@gmail.com" className="footer-link">amcinscription@gmail.com</a>
            </p>
          </Col>
          <Col xs={24} md={8} className="footer-section">
            <h3 className="footer-title">Navigation</h3>
            <p><a href="/coursEnfants" className="footer-link">Cours enfants</a></p>
            <p><a href="/coursAdultes" className="footer-link">Cours adultes</a></p>
            <p><a href="/adhesionInfos" className="footer-link">Adhésion</a></p>
          </Col>
          <Col xs={24} md={8} className="footer-section">
            <h3 className="footer-title">Suivez-nous</h3>
            <div className="social-icons">
              <a href="https://www.facebook.com/100012969094800" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </Col>
        </Row>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <p> 2023 Association Musulmane du Chablais. Tous droits réservés.</p>
        </div>
      </Footer>
      {isMobile && <BottomNavigation />}
    </Layout>
  );
}

export default App;